namespace TabAurous.Inventory {
    export interface LocationTransferItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        RefVoucherId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        RoutingId: Serenity.DecimalEditor;
        GroupId: Serenity.DecimalEditor;
        Studded: Serenity.IntegerEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        HasBom: Serenity.BooleanEditor;
        ProductName: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: Serenity.LookupEditor;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        MetalId: Serenity.IntegerEditor;
        Attribute: Serenity.StringEditor;
        CalcUnitId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        Hallmark: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        OtherRate: AmountEditor;
        UnitLabour: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        UnitCost: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        ImageName: Serenity.StringEditor;
        BOMDetails: LocationTransferBOMEditor;
    }

    export class LocationTransferItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.LocationTransferItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LocationTransferItemsForm.init)  {
                LocationTransferItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.LookupEditor;
                var w5 = CommonSubCategoryLookup;
                var w6 = CommonProductSizeLookup;
                var w7 = StoneSieveLookup;
                var w8 = WeightEditor;
                var w9 = AmountEditor;
                var w10 = LocationTransferBOMEditor;

                Q.initFormType(LocationTransferItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'RefVoucherId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'RefNo', w0,
                    'RoutingId', w2,
                    'GroupId', w2,
                    'Studded', w1,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'DesignId', w0,
                    'ProductCode', w0,
                    'DesignCode', w0,
                    'HasBom', w3,
                    'ProductName', w0,
                    'AttributeId', w0,
                    'ProductTypeId', w4,
                    'CategoryId', w4,
                    'SubCategoryId', w5,
                    'BrandId', w4,
                    'SuperTypeId', w4,
                    'CollectionId', w4,
                    'ProductSizeId', w6,
                    'MetalId', w1,
                    'Attribute', w0,
                    'CalcUnitId', w4,
                    'KaratId', w4,
                    'MetalColorId', w4,
                    'ShapeId', w4,
                    'StoneColorId', w4,
                    'QualityId', w4,
                    'StoneSizeId', w4,
                    'SieveId', w7,
                    'GroupSieveId', w7,
                    'StoneCutId', w4,
                    'StonePolishId', w4,
                    'StoneSymmetryId', w4,
                    'StoneFluorescenceId', w4,
                    'StoneCuletId', w4,
                    'StoneGirdleId', w4,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'Lab', w4,
                    'CertificateNo', w0,
                    'Hallmark', w4,
                    'Pieces', w1,
                    'Weight', w8,
                    'UnitRate', w2,
                    'StoneRate', w9,
                    'OtherRate', w9,
                    'UnitLabour', w2,
                    'NetAmount', w2,
                    'GrossAmount', w2,
                    'CCNetAmount', w2,
                    'CCGrossAmount', w2,
                    'Line_No', w0,
                    'HSN', w4,
                    'NetWeight', w8,
                    'DiamondPieces', w1,
                    'DiamondWeight', w8,
                    'StonePieces', w1,
                    'StoneWeight', w8,
                    'OtherPieces', w1,
                    'OtherWeight', w8,
                    'MetalAmount', w2,
                    'DiamondAmount', w2,
                    'StoneAmount', w2,
                    'OtherAmount', w2,
                    'CalcOnId', w4,
                    'UnitCost', w2,
                    'Discount', w2,
                    'Purity', w2,
                    'PureWeight', w8,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'AckStatus', w1,
                    'CompanyId', w1,
                    'ImageName', w0,
                    'BOMDetails', w10
                ]);
            }
        }
    }
}
